import { Grid } from "@mui/material";
import { createSelectable } from "react-selectable-fast";
import thumbnailVideo from "./../../Assets/Images/video-thumbnail-default.jpg"

const ImageItem = ({ selectableRef, isSelected, isSelecting, value })  => {
    return (
        <Grid item xs={2} sx={{position: 'relative'}}>
            <div ref={selectableRef} className={`cursor-pointer block-image ${isSelected ? "image-selected" : ""} ${isSelecting ? "selecting" : ""}`}>
                <img className='lib-image' src={(value.type === "file" || value.type === "url") ? value.link : thumbnailVideo} alt=""></img>
                <p>
                    {value.id}
                </p>
            </div>
        </Grid>
)
}

export default createSelectable(ImageItem);